"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
//derecated
var EUserRole;
(function (EUserRole) {
    EUserRole["RESIDENT"] = "RESIDENT";
    EUserRole["MANAGER"] = "MANAGER";
    EUserRole["FACILITY_MANAGER"] = "FACILITY_MANAGER";
    EUserRole["CHAIN_MANAGER"] = "CHAIN_MANAGER";
    EUserRole["ADMIN"] = "ADMIN";
    EUserRole["SALES_REP"] = "SALES_REP";
})(EUserRole = exports.EUserRole || (exports.EUserRole = {}));
var EViewedUpdate;
(function (EViewedUpdate) {
    EViewedUpdate["Pesach"] = "Pesach";
    EViewedUpdate["Shavuot"] = "Shavuot";
})(EViewedUpdate = exports.EViewedUpdate || (exports.EViewedUpdate = {}));
var EUserType;
(function (EUserType) {
    EUserType["ZUNTA"] = "ZUNTA";
    EUserType["CLIENT"] = "CLIENT";
    EUserType["RESIDENT"] = "RESIDENT";
})(EUserType = exports.EUserType || (exports.EUserType = {}));
var EUserStatus;
(function (EUserStatus) {
    EUserStatus["ACTIVE"] = "ACTIVE";
    EUserStatus["NOT_ACTIVE"] = "NOT_ACTIVE";
    EUserStatus["WAITING"] = "WAITING";
})(EUserStatus = exports.EUserStatus || (exports.EUserStatus = {}));
var EBriefingTime;
(function (EBriefingTime) {
    EBriefingTime["MORNING"] = "MORNING";
    EBriefingTime["EVENING"] = "EVENING";
    EBriefingTime["AFTERNOON"] = "AFTERNOON";
})(EBriefingTime = exports.EBriefingTime || (exports.EBriefingTime = {}));
var EPaymentEmailSettings;
(function (EPaymentEmailSettings) {
    EPaymentEmailSettings["NEVER"] = "NEVER";
    EPaymentEmailSettings["ALL_PAYMENTS"] = "ALL_PAYMENTS";
    EPaymentEmailSettings["ONLY_RESIDENT_PORTAL_PAYMENTS"] = "ONLY_RESIDENT_PORTAL_PAYMENTS";
})(EPaymentEmailSettings = exports.EPaymentEmailSettings || (exports.EPaymentEmailSettings = {}));
var EUserResponsibilities;
(function (EUserResponsibilities) {
    EUserResponsibilities["MANAGER"] = "manager";
    EUserResponsibilities["BILLING_CONTACT"] = "billing_contact";
    EUserResponsibilities["MAIL_STATEMENTS"] = "mail_statements";
    EUserResponsibilities["POST_PAYMENTS"] = "post_payments";
    EUserResponsibilities["COLLECTIONS"] = "collections";
    EUserResponsibilities["REVIEW_PAYMENTS"] = "review_payments";
})(EUserResponsibilities = exports.EUserResponsibilities || (exports.EUserResponsibilities = {}));
var EBriefingType;
(function (EBriefingType) {
    EBriefingType["QUOTE"] = "QUOTE";
    EBriefingType["MESSAGE"] = "MESSAGE";
    EBriefingType["IMAGE"] = "IMAGE";
})(EBriefingType = exports.EBriefingType || (exports.EBriefingType = {}));
var ETrainingMilestoneStatus;
(function (ETrainingMilestoneStatus) {
    ETrainingMilestoneStatus["COMPLETE"] = "COMPLETE";
    ETrainingMilestoneStatus["TODO"] = "TODO";
})(ETrainingMilestoneStatus = exports.ETrainingMilestoneStatus || (exports.ETrainingMilestoneStatus = {}));
var EQaReportType;
(function (EQaReportType) {
    EQaReportType["QA_SQL_REPORT"] = "QA_SQL_REPORT";
    EQaReportType["QA_CHAIN_AUTO_UPDATE_REPORT"] = "QA_CHAIN_AUTO_UPDATE_REPORT";
    EQaReportType["EMPTY_BATCHES_REGENERATION_REPORT"] = "EMPTY_BATCHES_REGENERATION_REPORT";
    EQaReportType["QA_DEPOSITS_REPORT"] = "QA_DEPOSITS_REPORT";
    EQaReportType["PAYMENTS_WITH_NO_WILLOW_ID_REPORT"] = "PAYMENTS_WITH_NO_WILLOW_ID_REPORT";
})(EQaReportType = exports.EQaReportType || (exports.EQaReportType = {}));
__export(require("./holidayPopup"));
